import { CircleVariant, ColorVariant } from '@invitae/iconograph-core';
import { Colors } from './colors.esm.js';

/**
 * Converts a set of variant props into color and circle options for SVGR components
 */
var variantToProps = function (_a) {
    var color = _a.color, circle = _a.circle, currentColor = _a.currentColor;
    var primary = '';
    var secondary = '';
    var circleStroke = '';
    var circleFill = '';
    var iconFace = '';
    var colorOption = color;
    /**
     * If CircleVariant is set to solid, override any ColorVariant settings
     */
    if (circle === CircleVariant.solid && color !== ColorVariant.none) {
        colorOption = ColorVariant.none;
    }
    /**
     * support for currentColor option - overrides any ColorVariant settings
     */
    var iconFaceColor = currentColor ? 'currentcolor' : Colors.dark;
    if (currentColor && colorOption !== ColorVariant.none) {
        colorOption = ColorVariant.none;
    }
    switch (circle) {
        case CircleVariant.yes: {
            circleStroke = iconFaceColor;
            circleFill = Colors.transparent;
            iconFace = iconFaceColor;
            break;
        }
        case CircleVariant.no: {
            circleStroke = Colors.transparent;
            circleFill = Colors.transparent;
            iconFace = iconFaceColor;
            break;
        }
        case CircleVariant.solid: {
            circleStroke = iconFaceColor;
            circleFill = iconFaceColor;
            iconFace = Colors.light;
            break;
        }
        /**
         * If color is missing or unrecognized, go with 'circle=yes' option
         */
        default: {
            circleStroke = iconFaceColor;
            circleFill = Colors.transparent;
            iconFace = iconFaceColor;
            break;
        }
    }
    switch (colorOption) {
        case ColorVariant.none: {
            primary = Colors.transparent;
            secondary = Colors.transparent;
            break;
        }
        case ColorVariant.bermudaViola: {
            primary = Colors.bermuda;
            secondary = Colors.viola;
            break;
        }
        case ColorVariant.violaPolo: {
            primary = Colors.viola;
            secondary = Colors.polo;
            break;
        }
        case ColorVariant.buttermilkBermuda: {
            primary = Colors.buttermilk;
            secondary = Colors.bermuda;
            break;
        }
        case ColorVariant.poloMint: {
            primary = Colors.mint;
            secondary = Colors.polo;
            break;
        }
        /** If color is missing or unrecognized go with 'color=none' */
        default: {
            primary = Colors.transparent;
            secondary = Colors.transparent;
            break;
        }
    }
    return {
        primary: primary,
        secondary: secondary,
        circleStroke: circleStroke,
        circleFill: circleFill,
        iconFace: iconFace,
    };
};

export { variantToProps };
//# sourceMappingURL=variant-to-props.esm.js.map
